import { CURRENT_NETWORK } from '../config/networks';

export const switchToTargetNetwork = async (provider) => {
  if (!provider || !provider.request) throw new Error('No wallet provider');

  const targetChainIdHex = CURRENT_NETWORK.chainIdHex;

  try {
    await provider.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: targetChainIdHex }]
    });
    return true;
  } catch (err) {
    if (err.code === 4902 || err.code === -32603 || (err.data && err.data.originalError && err.data.originalError.code === 4902)) {
      try {
        await provider.request({
          method: 'wallet_addEthereumChain',
          params: [{
            chainId: targetChainIdHex,
            chainName: CURRENT_NETWORK.name,
            nativeCurrency: CURRENT_NETWORK.nativeCurrency,
            rpcUrls: CURRENT_NETWORK.rpcUrls,
            blockExplorerUrls: CURRENT_NETWORK.blockExplorerUrls
          }]
        });
        return true;
      } catch (addErr) {
        throw addErr;
      }
    }
    throw err;
  }
};

export const isCorrectNetwork = (chainId) => {
  if (!chainId) return false;
  const cid = typeof chainId === 'string' ? parseInt(chainId, 16) : Number(chainId);
  return cid === CURRENT_NETWORK.chainId;
};

export const detectProvider = () => {
  if (typeof window === 'undefined') return null;

  const eth = window.ethereum;
  if (!eth) return null;

  if (eth.providers && Array.isArray(eth.providers) && eth.providers.length > 0) {
    const trust = eth.providers.find((p) => p.isTrust || p.isTrustWallet);
    if (trust) return trust;
    const metamask = eth.providers.find((p) => p.isMetaMask);
    if (metamask) return metamask;
    return eth.providers[0];
  }
  return eth;
};
